import store from '@/store/index.js'

// 管理数据
let accessToken = localStorage.getItem('accessToken')
let expiredTime = localStorage.getItem('expiredTime')

if ((accessToken == null || accessToken == "") || (expiredTime == null || expiredTime == "")) {
    store.dispatch('adminLeave', {})
}
else {
    let currentTime = new Date().getTime();
    let compareTime = new Date(Date.parse(expiredTime.replace(/-/g, "/"))).getTime();
    if (currentTime > compareTime) {
        store.dispatch('adminLeave', {})
    }
    else {
        // 回写持久化数据
        let adminUser = {
            accessToken: localStorage.getItem('accessToken'),
            expiredTime: localStorage.getItem('expiredTime'),
            userId: localStorage.getItem('adminId'),
            userOrganizationId: localStorage.getItem('adminOrganizationId'),
            userType: localStorage.getItem('adminType'),
            userAccount: localStorage.getItem('adminAccount'),
            userName: localStorage.getItem('adminName'),
        }
        store.commit('SET_ADMINUSER', adminUser)
    }
}

// 用户数据
let userId = localStorage.getItem('userId')
if (userId != null && userId != '') {
    let userInfo = {
        userId: userId
    }
    store.commit('systemuser/SET_USERINFO', userInfo)
}